var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-name", class: { "cog-name--narrow": _vm.isNarrow } },
    [
      _vm.readonly
        ? _c("div", { staticClass: "cog-input is-read-only" }, [
            _vm._v(_vm._s(_vm.name.toString(_vm.format)))
          ])
        : _c(
            "c-row",
            [
              _c(
                "c-wrap",
                {
                  staticClass: "cog-name__group",
                  attrs: {
                    when:
                      _vm.includeProperty("Prefix") &&
                      _vm.includeProperty("MiddleInitial") &&
                      _vm.includeProperty("Suffix")
                  }
                },
                [
                  _vm.includeProperty("Prefix")
                    ? _c("c-input", {
                        staticClass: "cog-name__prefix cog-input--small",
                        attrs: {
                          placeholder: _vm.$resource("name-prefix"),
                          title: _vm.$resource("name-prefix"),
                          label: _vm.$resource("name-prefix"),
                          readonly: _vm.readonly,
                          autocomplete: "honorific-prefix"
                        },
                        model: {
                          value: _vm.name.Prefix,
                          callback: function($$v) {
                            _vm.$set(_vm.name, "Prefix", $$v)
                          },
                          expression: "name.Prefix"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("c-input", {
                    staticClass: "cog-name__first cog-input--long",
                    attrs: {
                      placeholder: _vm.$resource("name-first"),
                      title: _vm.$resource("name-first"),
                      label: _vm.$resource("name-first"),
                      readonly: _vm.readonly,
                      autocomplete: "given-name"
                    },
                    model: {
                      value: _vm.name.First,
                      callback: function($$v) {
                        _vm.$set(_vm.name, "First", $$v)
                      },
                      expression: "name.First"
                    }
                  }),
                  _vm._v(" "),
                  _vm.includeProperty("MiddleInitial")
                    ? _c("c-input", {
                        staticClass: "cog-name__middle-initial cog-input--tiny",
                        attrs: {
                          placeholder: _vm.$resource("name-middleinitial"),
                          title: _vm.$resource("name-middleinitial"),
                          label: _vm.$resource("name-middleinitial"),
                          readonly: _vm.readonly,
                          maxlength: 1,
                          autocomplete: "additional-name"
                        },
                        model: {
                          value: _vm.name.MiddleInitial,
                          callback: function($$v) {
                            _vm.$set(_vm.name, "MiddleInitial", $$v)
                          },
                          expression: "name.MiddleInitial"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.includeProperty("Middle")
                    ? _c("c-input", {
                        staticClass: "cog-name__middle cog-input--long",
                        attrs: {
                          placeholder: _vm.$resource("name-middle"),
                          title: _vm.$resource("name-middle"),
                          label: _vm.$resource("name-middle"),
                          readonly: _vm.readonly,
                          autocomplete: "additional-name"
                        },
                        model: {
                          value: _vm.name.Middle,
                          callback: function($$v) {
                            _vm.$set(_vm.name, "Middle", $$v)
                          },
                          expression: "name.Middle"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "c-wrap",
                {
                  staticClass: "cog-name__group",
                  attrs: {
                    when:
                      _vm.includeProperty("Last") &&
                      _vm.includeProperty("Suffix")
                  }
                },
                [
                  _c("c-input", {
                    staticClass: "cog-name__last cog-input--long",
                    attrs: {
                      placeholder: _vm.$resource("name-last"),
                      title: _vm.$resource("name-last"),
                      label: _vm.$resource("name-last"),
                      readonly: _vm.readonly,
                      autocomplete: "family-name"
                    },
                    model: {
                      value: _vm.name.Last,
                      callback: function($$v) {
                        _vm.$set(_vm.name, "Last", $$v)
                      },
                      expression: "name.Last"
                    }
                  }),
                  _vm._v(" "),
                  _vm.includeProperty("Suffix")
                    ? _c("c-input", {
                        staticClass: "cog-name__suffix cog-input--small",
                        attrs: {
                          placeholder: _vm.$resource("name-suffix"),
                          title: _vm.$resource("name-suffix"),
                          label: _vm.$resource("name-suffix"),
                          readonly: _vm.readonly,
                          autocomplete: "honorific-suffix"
                        },
                        model: {
                          value: _vm.name.Suffix,
                          callback: function($$v) {
                            _vm.$set(_vm.name, "Suffix", $$v)
                          },
                          expression: "name.Suffix"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }